import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { pb } from '@/lib/pocketbase';

export const useInstantSessionApproval = () => {
  const { user } = useAuth();
  const [isApproved, setIsApproved] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [approvalNotes, setApprovalNotes] = useState<string>('');

  useEffect(() => {
    const fetchApprovalStatus = async () => {
      if (!user || user.role !== 'tutor') {
        setIsLoading(false);
        return;
      }

      try {
        const tutorProfile = await pb.collection('tutors').getFirstListItem(
          `user = "${user.id}"`
        );
        
        setIsApproved(!!tutorProfile.instant_session_approved);
        setApprovalNotes(tutorProfile.instant_session_notes || '');
      } catch (error) {
        console.error('Error fetching instant session approval status:', error);
        setIsApproved(false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchApprovalStatus();
  }, [user]);

  return {
    isApproved,
    isLoading,
    approvalNotes
  };
};